import {
  FirestoreDataConverter,
  QueryDocumentSnapshot,
  SnapshotOptions,
} from "firebase/firestore";
import { PhotoTaskTemplate } from "../photos/photoTaskTemplate";

export const photoTaskTemplateConverter: FirestoreDataConverter<PhotoTaskTemplate> =
  {
    toFirestore(template: PhotoTaskTemplate) {
      // Clean up undefined values from tasks
      const cleanTasks = template.tasks.map(task => {
        const cleanTask: any = {
          id: task.id,
          displayName: task.displayName,
          order: task.order,
          active: task.active,
          mediaType: task.mediaType,
        }
        
        // Only add optional fields if they have values
        if (task.storagePath) cleanTask.storagePath = task.storagePath
        if (task.videoStoragePath) cleanTask.videoStoragePath = task.videoStoragePath
        if (task.placeholderText) cleanTask.placeholderText = task.placeholderText
        
        return cleanTask
      })
      
      const result: any = {
        id: template.id,
        name: template.name,
        tasks: cleanTasks,
        createdAt: template.createdAt || new Date().toISOString(),
        updatedAt: new Date().toISOString(),
      };
      
      // Only include optional company_id if it exists
      if (template.company_id) {
        result.company_id = template.company_id;
      }
      
      return result;
    },
    fromFirestore: (
      snapshot: QueryDocumentSnapshot,
      options?: SnapshotOptions
    ): PhotoTaskTemplate => {
      const data = snapshot.data(options);
      return {
        id: data.id,
        name: data.name,
        tasks: (data.tasks || []).map((t: any) => ({
          ...t,
          mediaType: t.mediaType || 'photo',
          active: t.active !== undefined ? t.active : true,
          storagePath: t.storagePath || undefined,
          videoStoragePath: t.videoStoragePath || undefined,
          placeholderText: t.placeholderText || undefined,
        })),
        createdAt: data.createdAt || new Date().toISOString(),
        updatedAt: data.updatedAt || new Date().toISOString(),
        company_id: data.company_id || undefined,
      };
    },
  };
